import { ACCOUNTING_CLASSES_ACTION_TYPE } from '../actions';

const initialState = null;

const classesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACCOUNTING_CLASSES_ACTION_TYPE.GET_CLASSES:
      return payload || state;

    default:
      return state;
  }
};

export default classesReducer;
